import React, { Component } from 'react';
import PropTypes from 'prop-types';
import KVButton from '../button';

import './styles.css';

// Sentry (Raven) is not loaded in every environment: calling it blindly threw
// a second error inside componentDidCatch and left the whole admin blank.
export const reportError = (error, errorInfo) => {
  if (window.Raven && typeof window.Raven.captureException === 'function') {
    window.Raven.captureException(error, { extra: errorInfo });
  } else {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }
};

/**
 * If a screen breaks while rendering, shows a notice inside the content area
 * (header and menu stay usable) instead of a blank page. Changing `resetKey`
 * (the current path) clears it, so moving to another section works again.
 */
class ScreenErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, errorInfo);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  retry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <div className="screen-error" role="alert">
        <i className="fa fa-exclamation-triangle" aria-hidden="true" />
        <h3>Algo falló en esta pantalla</h3>
        <p>
          No se perdió nada de lo que ya estaba guardado. Probá de nuevo o entrá
          a otra sección desde el menú.
        </p>
        <KVButton kvType="primary" onClick={this.retry}>
          Volver a intentar
        </KVButton>
      </div>
    );
  }
}

ScreenErrorBoundary.propTypes = {
  children: PropTypes.node,
  resetKey: PropTypes.string
};

export default ScreenErrorBoundary;
